import { createSelector } from 'reselect'

const getNormalizedChildren = state => state.Children.children

const getChildrenResult = createSelector(
  [getNormalizedChildren],
  children => (!children ? null : children.result)
)

const getChildren = createSelector(
  [getNormalizedChildren],
  children => (!children ? null : children.entities.children)
)

const getChildrenList = createSelector(
  [getChildrenResult, getChildren],
  (result, children) => (!result ? null : result.map(id => children[id]))
)

const getFetchChildrenRequest = state => state.Children.fetchChildrenRequest

const getChild = (state, id) => getChildren(state)[id]

export { getChildrenList, getChild, getFetchChildrenRequest }
